import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {PermissionsKeys} from '@dms/shared';

export type CustomFieldsResourcePermission = Extract<
  PermissionsKeys,
  | 'vehicleRead'
  | 'interestRead'
  | 'businessCaseRead'
  | 'serviceCaseRead'
  | 'workshopInterestRead'
  | 'readRentalOrder'
  | 'employeeRead'
>;

export type CustomFieldsResource = {
  resourceId: EntityResourceIds;
  label: string;
  permission: CustomFieldsResourcePermission;
};

export const CUSTOM_FIELDS_RESOURCES = [
  {
    resourceId: EntityResourceIds.vehicle,
    label: i18n.t('entity.vehicle.labels.vehicle'),
    permission: 'vehicleRead',
  },
  {
    resourceId: EntityResourceIds.customer,
    label: i18n.t('entity.customer.labels.customer'),
    permission: 'vehicleRead',
  },
  {
    resourceId: EntityResourceIds.interest,
    label: i18n.t('entity.interest.labels.interest'),
    permission: 'interestRead',
  },
  {
    resourceId: EntityResourceIds.businessCase,
    label: i18n.t('general.labels.businessCase'),
    permission: 'businessCaseRead',
  },
  {
    resourceId: EntityResourceIds.serviceCase,
    label: i18n.t('page.workshop.labels.serviceCases'),
    permission: 'serviceCaseRead',
  },
  {
    resourceId: EntityResourceIds.workshopInterest,
    label: i18n.t('page.workshop.labels.workshopInterest'),
    permission: 'workshopInterestRead',
  },
  {
    resourceId: EntityResourceIds.rentalOrder,
    label: i18n.t('entity.rentalOrder.labels.rentalOrder'),
    permission: 'readRentalOrder',
  },
  {
    resourceId: EntityResourceIds.employee,
    label: i18n.t('general.labels.employee'),
    permission: 'employeeRead',
  },
] satisfies CustomFieldsResource[];
